import type { ListingOfferCardProps } from 'app/types/listing-offer-card-props';
import { ListingOfferCardBase } from './listing-offer-card.base';

export const OFFER_CARD_GRID_WIDTH = 196;

function ListingOfferCardLarge(props: ListingOfferCardProps) {
  return <ListingOfferCardBase {...props} variant="large" />;
}

export { ListingOfferCardLarge };
